import React from "react";
import Euflag from "../assets/images/Euflag.png";
import Leaderupdated from "../assets/images/Leaderupdated.png";
import SpbSkane from "../assets/images/SpbSkane.png";
import Swedbank from "../assets/images/Swedbank.png";
import falsterbostrand from "../assets/images/falsterbostrand.jpg";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import AboutSection from "../components/AboutSection";
import LogoCloudSection from "../components/sections/LogoCloudSection";

const scrollToSection = (sectionId) => {
    const targetSection = document.getElementById(sectionId);
    if (targetSection) {
        targetSection.scrollIntoView({ behavior: "smooth" });
    }
};

export default function AboutNB() {
    return (
        <div className="flex flex-col min-h-screen bg-offwhite font-body">
            <Navbar />
            <main className="flex-grow pt-[56px]">
                {/* Section 1 */}
                <AboutSection
                    id="section1"
                    title="Om Naturborgarmärket"
                    backgroundImage={falsterbostrand}
                    overlayOpacity={30}
                    textColor="text-charcoal"
                    onNavigateDown={() => scrollToSection("logo-cloud")}
                >
                    <p className="font-body text-sm sm:text-base md:text-lg lg:text-xl leading-relaxed">
                        Naturborgarmärket syftar till att utveckla allmänhetens kunskap om olika arter som finns i
                        vår natur. Idén går ut på att skapa ett interaktivt lärande där användaren måste befinna
                        sig i naturen och aktivt leta efter och se olika arter, där kunskapen om dessa arter sedan testas
                        i ett kunskapstest. Om användaren klarar kunskapstestet så belönas detta med ett
                        fysiskt naturborgarmärke som erhålls genom beställning efter avklarat test. Detta kan sedan
                        t.ex. sys på en ryggsäck eller sättas fast på jackan.
                    </p>
                </AboutSection>

                {/* Section 2 - Logo Cloud */}
                <div id="logo-cloud">
                    <LogoCloudSection
                        title="Utvecklingen av Naturborgarmärket stödjs av:"
                        description="Utvecklingen av Naturborgarmärket stöds av: Swedbank genom Sparbanksstiftelsen Skåne, Europeiska jordbruksfonden för Landsbygdsutveckling genom LEADER Söderslätt"
                        backgroundColor="off-white"
                        logos={[
                            { img: Swedbank, title: "Swedbank" },
                            { img: SpbSkane, title: "Sparbanksstiftelsen Skåne" },
                            { img: Euflag, title: "EU" },
                            { img: Leaderupdated, title: "Leader" },
                        ]}
                    />
                </div>
            </main>
            <Footer />
        </div>
    );
}
